import { SchvalenieGestoraApi } from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new SchvalenieGestoraApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const odoslatNaSchvalenie = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: string,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.odoslatNaSchvalenieGestora(type, year, index, pracovnyKrokId, headers);
  return { responseCode: status };
};
